var map = {
	"./0xbtc.svg": 46521,
	"./1000sats.svg": 61564,
	"./1inch.svg": 15221,
	"./1sol.svg": 40453,
	"./1st.svg": 56096,
	"./3p.svg": 99053,
	"./5ire.svg": 32209,
	"./REEF.svg": 75182,
	"./REI.svg": 53636,
	"./RONIN.svg": 23528,
	"./aark.svg": 51523,
	"./aave.svg": 42065,
	"./abbc.svg": 68404,
	"./abt.svg": 37443,
	"./ac3.svg": 7167,
	"./aca.svg": 79773,
	"./ace.svg": 38977,
	"./ach.svg": 27348,
	"./acm.svg": 68121,
	"./acs.svg": 10943,
	"./act.svg": 45056,
	"./ada.svg": 97472,
	"./ada2l.svg": 40618,
	"./ada2s.svg": 35853,
	"./adb.svg": 18227,
	"./adx.svg": 20537,
	"./ae.svg": 74506,
	"./aeg.svg": 67625,
	"./aeon.svg": 41013,
	"./aergo.svg": 8430,
	"./aeur.svg": 67715,
	"./aevo.svg": 71647,
	"./afc.svg": 13672,
	"./afg.svg": 61972,
	"./agi.svg": 21073,
	"./agix.svg": 30507,
	"./agla.svg": 44485,
	"./agld.svg": 75992,
	"./ai.svg": 7006,
	"./aidoge.svg": 35533,
	"./aion.svg": 72985,
	"./aioz.svg": 7589,
	"./ait.svg": 19550,
	"./aki.svg": 52381,
	"./akro.svg": 32557,
	"./akt.svg": 99512,
	"./alcx.svg": 67982,
	"./aleph.svg": 68700,
	"./algo.svg": 66893,
	"./alice.svg": 18068,
	"./alis.svg": 15843,
	"./alpaca.svg": 26398,
	"./alpha.svg": 83128,
	"./alpine.svg": 30885,
	"./alt.svg": 38773,
	"./alx.svg": 59553,
	"./amb.svg": 53436,
	"./amlt.svg": 84746,
	"./amp.svg": 52974,
	"./ampl.svg": 46838,
	"./anc.svg": 67936,
	"./anj.svg": 58473,
	"./ankr.svg": 88858,
	"./ant.svg": 84879,
	"./ape.svg": 69640,
	"./ape2l.svg": 77538,
	"./ape2s.svg": 74325,
	"./apex.svg": 46608,
	"./aph.svg": 46685,
	"./api3.svg": 52823,
	"./apl.svg": 5889,
	"./app.svg": 72197,
	"./appc.svg": 28700,
	"./aprs.svg": 80422,
	"./apt.svg": 79209,
	"./aptr.svg": 12409,
	"./apw.svg": 94746,
	"./apy.svg": 98828,
	"./ar.svg": 4485,
	"./arb.svg": 62045,
	"./ardr.svg": 22747,
	"./ark.svg": 58036,
	"./arkm.svg": 28729,
	"./armor.svg": 21361,
	"./arn.svg": 16217,
	"./aro.svg": 3848,
	"./arpa.svg": 5164,
	"./arrr.svg": 13765,
	"./arty.svg": 30112,
	"./asr.svg": 51838,
	"./ast.svg": 78096,
	"./astr.svg": 74050,
	"./ata.svg": 76240,
	"./ath.svg": 40921,
	"./atm.svg": 81300,
	"./atmi.svg": 46133,
	"./atom.svg": 86351,
	"./atom2l.svg": 681,
	"./atom2s.svg": 72894,
	"./auc.svg": 49493,
	"./auction.svg": 32835,
	"./audio.svg": 9274,
	"./aura.svg": 22285,
	"./aurora.svg": 95208,
	"./aury.svg": 9781,
	"./auto.svg": 98273,
	"./ava.svg": 72314,
	"./avax.svg": 20558,
	"./avax2l.svg": 81092,
	"./avax2s.svg": 44931,
	"./awc.svg": 13691,
	"./axl.svg": 41289,
	"./axp.svg": 8765,
	"./axs.svg": 54590,
	"./azy.svg": 19886,
	"./babydoge.svg": 80111,
	"./bac.svg": 99066,
	"./badger.svg": 14005,
	"./bake.svg": 25747,
	"./bal.svg": 2093,
	"./band.svg": 89169,
	"./bao.svg": 53742,
	"./bar.svg": 8347,
	"./bat.svg": 71189,
	"./bay.svg": 74672,
	"./bb.svg": 30352,
	"./bbl.svg": 33204,
	"./bbr.svg": 85346,
	"./bcd.svg": 40063,
	"./bch.svg": 71563,
	"./bcha.svg": 69008,
	"./bcn.svg": 1221,
	"./bco.svg": 3972,
	"./bcut.svg": 12318,
	"./beam.svg": 64481,
	"./beamx.svg": 92763,
	"./bel.svg": 83161,
	"./beta.svg": 16754,
	"./beth.svg": 24379,
	"./bf.svg": 17212,
	"./bgb.svg": 49477,
	"./bico.svg": 37161,
	"./bifi.svg": 50500,
	"./bigtime.svg": 85297,
	"./bix.svg": 41273,
	"./blast.svg": 3490,
	"./blk.svg": 21057,
	"./block.svg": 30135,
	"./blt.svg": 45702,
	"./blue.svg": 27624,
	"./blur.svg": 77879,
	"./blz.svg": 57760,
	"./bnb.svg": 19038,
	"./bnt.svg": 44832,
	"./bnx.svg": 61796,
	"./bob.svg": 76749,
	"./boba.svg": 87958,
	"./bome.svg": 71803,
	"./bond.svg": 67991,
	"./bondly.svg": 54538,
	"./bone.svg": 69958,
	"./bonk.svg": 32160,
	"./bonus.svg": 44041,
	"./bora.svg": 65990,
	"./box.svg": 37799,
	"./bpt.svg": 54674,
	"./brawl.svg": 4512,
	"./brd.svg": 33836,
	"./brett.svg": 8429,
	"./bsv.svg": 16877,
	"./bsw.svg": 81420,
	"./btc++.svg": 60835,
	"./btc.svg": 77121,
	"./btc3l.svg": 24564,
	"./btc3s.svg": 29459,
	"./btcd.svg": 87935,
	"./btcp.svg": 83619,
	"./btg.svg": 1565,
	"./btmx.svg": 94909,
	"./bto.svg": 38101,
	"./bts.svg": 19153,
	"./btt.svg": 20654,
	"./bttc.svg": 24993,
	"./btu.svg": 49087,
	"./bu.svg": 21503,
	"./bubble.svg": 36902,
	"./bunny.svg": 18012,
	"./burger.svg": 66907,
	"./busd.svg": 82126,
	"./bwt.svg": 86059,
	"./bz.svg": 34968,
	"./bznt.svg": 42462,
	"./bzrx.svg": 62286,
	"./c20.svg": 4205,
	"./c98.svg": 90756,
	"./cake.svg": 38432,
	"./candy.svg": 67847,
	"./capo.svg": 69435,
	"./capp.svg": 59788,
	"./caps.svg": 38815,
	"./car.svg": 84726,
	"./card.svg": 62870,
	"./cat.svg": 59368,
	"./cbat.svg": 10376,
	"./cbk.svg": 9542,
	"./cbt.svg": 68545,
	"./cbx.svg": 3349,
	"./cdai.svg": 56199,
	"./cdt.svg": 21055,
	"./cel.svg": 63620,
	"./celo.svg": 43819,
	"./celr.svg": 3678,
	"./cennz.svg": 55774,
	"./ceth.svg": 25148,
	"./cetus.svg": 91176,
	"./cfx.svg": 69969,
	"./cgpt.svg": 18494,
	"./chai.svg": 65131,
	"./chat.svg": 97310,
	"./chr.svg": 32397,
	"./chrp.svg": 69847,
	"./chsb.svg": 7878,
	"./chz.svg": 25221,
	"./city.svg": 24009,
	"./ckb.svg": 51256,
	"./clo.svg": 36780,
	"./cloak.svg": 9492,
	"./clout.svg": 42679,
	"./clv.svg": 76085,
	"./cmp.svg": 8504,
	"./cmt.svg": 1540,
	"./cnd.svg": 26749,
	"./cnx.svg": 59273,
	"./co.svg": 22650,
	"./com.svg": 59075,
	"./combo.svg": 48982,
	"./comp.svg": 61689,
	"./coni.svg": 49337,
	"./cookie.svg": 70126,
	"./coq.svg": 98103,
	"./core.svg": 87793,
	"./cos.svg": 40901,
	"./cosm.svg": 69642,
	"./cot.svg": 17370,
	"./coti.svg": 99343,
	"./cov.svg": 53176,
	"./cova.svg": 47417,
	"./cover.svg": 40765,
	"./cpc.svg": 34628,
	"./cpool.svg": 16385,
	"./crds.svg": 32272,
	"./cre.svg": 2768,
	"./cream.svg": 84006,
	"./cred.svg": 89980,
	"./crep.svg": 32224,
	"./cro.svg": 27658,
	"./crpt.svg": 90219,
	"./crv.svg": 40019,
	"./cs.svg": 36798,
	"./csai.svg": 52784,
	"./csc.svg": 45809,
	"./cspr.svg": 66348,
	"./cta.svg": 50370,
	"./ctc.svg": 34784,
	"./ctk.svg": 97784,
	"./ctsi.svg": 67993,
	"./ctt.svg": 59055,
	"./ctxc.svg": 48930,
	"./cult.svg": 20224,
	"./cusdc.svg": 76780,
	"./cv.svg": 48003,
	"./cvc.svg": 49402,
	"./cvp.svg": 33369,
	"./cvt.svg": 62645,
	"./cvx.svg": 7105,
	"./cwar.svg": 66815,
	"./cwbtc.svg": 40027,
	"./cyber.svg": 3375,
	"./czrx.svg": 98429,
	"./dadi.svg": 6452,
	"./dafi.svg": 16942,
	"./dag.svg": 62300,
	"./dai.svg": 95722,
	"./dar.svg": 87185,
	"./dash.svg": 50360,
	"./dat.svg": 82943,
	"./data.svg": 88236,
	"./datx.svg": 27541,
	"./dbc.svg": 55693,
	"./dcn.svg": 35023,
	"./dcr.svg": 82795,
	"./dct.svg": 96101,
	"./ddd.svg": 26584,
	"./dechat.svg": 3035,
	"./default.svg": 24179,
	"./default_dark.svg": 68874,
	"./defi.svg": 16338,
	"./defy.svg": 63778,
	"./degen.svg": 23865,
	"./dego.svg": 76383,
	"./dent.svg": 86127,
	"./deri.svg": 2550,
	"./devt.svg": 76711,
	"./dexe.svg": 36160,
	"./df.svg": 47342,
	"./dfi.svg": 61787,
	"./dft.svg": 93230,
	"./dfyn.svg": 1223,
	"./dgb.svg": 25695,
	"./dgd.svg": 29937,
	"./dgtx.svg": 56891,
	"./dia.svg": 31674,
	"./dice.svg": 45653,
	"./divi.svg": 63558,
	"./dlc.svg": 73919,
	"./dlt.svg": 80208,
	"./dmail.svg": 15605,
	"./dmt.svg": 99219,
	"./dnt.svg": 97974,
	"./dock.svg": 84641,
	"./dodo.svg": 96348,
	"./doge.svg": 98443,
	"./dome.svg": 44765,
	"./dop1.svg": 4750,
	"./dor.svg": 80535,
	"./dot.svg": 95593,
	"./dpx.svg": 57816,
	"./drep.svg": 12249,
	"./drgn.svg": 74117,
	"./drift.svg": 88781,
	"./drop.svg": 82379,
	"./dsrun.svg": 60306,
	"./dta.svg": 72117,
	"./dtr.svg": 41222,
	"./dtx.svg": 32812,
	"./duel.svg": 40530,
	"./dusk.svg": 73799,
	"./dvf.svg": 31756,
	"./dxd.svg": 96068,
	"./dxt.svg": 85652,
	"./dydx.svg": 58045,
	"./dym.svg": 15134,
	"./dzoo.svg": 29620,
	"./ecox.svg": 65341,
	"./edg.svg": 16402,
	"./edo.svg": 55210,
	"./efi.svg": 67278,
	"./efx.svg": 30415,
	"./egld.svg": 59772,
	"./ego.svg": 49891,
	"./egt.svg": 74616,
	"./ekg.svg": 4855,
	"./ekt.svg": 34964,
	"./ela.svg": 52068,
	"./elda.svg": 62970,
	"./elec.svg": 65819,
	"./elf.svg": 56747,
	"./elix.svg": 89148,
	"./elt.svg": 82425,
	"./emc.svg": 94841,
	"./emc2.svg": 53961,
	"./ena.svg": 52142,
	"./eng.svg": 49312,
	"./enj.svg": 44293,
	"./ens.svg": 64540,
	"./eos.svg": 62367,
	"./eosdac.svg": 24925,
	"./epx.svg": 97521,
	"./ern.svg": 71797,
	"./ertha.svg": 41886,
	"./esd.svg": 45676,
	"./ese.svg": 25389,
	"./esp.svg": 93520,
	"./ess.svg": 55011,
	"./etc.svg": 86606,
	"./eth.svg": 36229,
	"./eth3l.svg": 5728,
	"./eth3s.svg": 93703,
	"./ethfi.svg": 1050,
	"./ethw.svg": 84384,
	"./etn.svg": 43659,
	"./etp.svg": 41341,
	"./etz.svg": 60423,
	"./eur.svg": 83808,
	"./ever.svg": 52212,
	"./every.svg": 32677,
	"./evx.svg": 42719,
	"./ewt.svg": 86920,
	"./exrn.svg": 96687,
	"./exvg.svg": 86082,
	"./exy.svg": 82584,
	"./fab.svg": 4927,
	"./fame.svg": 22677,
	"./far.svg": 5007,
	"./farm.svg": 17704,
	"./fb.svg": 72044,
	"./fct.svg": 41931,
	"./feed.svg": 19856,
	"./fei.svg": 96784,
	"./fet.svg": 98629,
	"./fida.svg": 27114,
	"./fil.svg": 40257,
	"./filda.svg": 3980,
	"./fio.svg": 35218,
	"./fire.svg": 19560,
	"./firo.svg": 62674,
	"./fitfi.svg": 74454,
	"./flip.svg": 27821,
	"./flm.svg": 44163,
	"./floki.svg": 37057,
	"./flow.svg": 15292,
	"./flr.svg": 37796,
	"./flt.svg": 27866,
	"./flux.svg": 73577,
	"./fmb.svg": 21123,
	"./fmc.svg": 71730,
	"./fon.svg": 66957,
	"./for.svg": 4217,
	"./fort.svg": 24503,
	"./forth.svg": 71005,
	"./fota.svg": 12804,
	"./fox.svg": 96579,
	"./foxy.svg": 86480,
	"./frax.svg": 5127,
	"./frm.svg": 85921,
	"./front.svg": 71329,
	"./fsn.svg": 82513,
	"./ft.svg": 43442,
	"./ftc.svg": 95997,
	"./ftm.svg": 69691,
	"./ftt.svg": 86210,
	"./fuel.svg": 44760,
	"./fun.svg": 33599,
	"./fxc.svg": 75225,
	"./fxs.svg": 19401,
	"./fxt.svg": 89958,
	"./g3.svg": 11994,
	"./gal.svg": 68460,
	"./gala.svg": 67269,
	"./galaxis.svg": 28727,
	"./gas.svg": 78107,
	"./gdc.svg": 57100,
	"./gem.svg": 22073,
	"./gen.svg": 72778,
	"./gene.svg": 94475,
	"./gft.svg": 68825,
	"./gg.svg": 73270,
	"./glm.svg": 91074,
	"./glmr.svg": 19356,
	"./gm.svg": 70684,
	"./gmrx.svg": 58642,
	"./gmt.svg": 43960,
	"./gmx.svg": 75148,
	"./gno.svg": 75530,
	"./gns.svg": 64942,
	"./gnt.svg": 63441,
	"./gnx.svg": 87717,
	"./go.svg": 70782,
	"./goc.svg": 15857,
	"./gods.svg": 58833,
	"./got.svg": 60446,
	"./gpt.svg": 93671,
	"./grape.svg": 92973,
	"./grin.svg": 57358,
	"./grs.svg": 61538,
	"./grt.svg": 70829,
	"./gsc.svg": 49301,
	"./gst.svg": 93530,
	"./gsts.svg": 16197,
	"./gswap.svg": 806,
	"./gswift.svg": 56732,
	"./gt.svg": 19845,
	"./gtai.svg": 60875,
	"./gtc.svg": 35868,
	"./gto.svg": 5768,
	"./gummy.svg": 7659,
	"./gusd.svg": 22977,
	"./gvt.svg": 7305,
	"./gxs.svg": 10368,
	"./hakka.svg": 49500,
	"./hbar.svg": 23195,
	"./hc.svg": 80607,
	"./hedg.svg": 31250,
	"./her.svg": 60433,
	"./hero.svg": 61012,
	"./hex.svg": 68843,
	"./hft.svg": 27122,
	"./hifi.svg": 47002,
	"./high.svg": 37864,
	"./hive.svg": 58238,
	"./hlg.svg": 10087,
	"./hnt.svg": 82234,
	"./hon.svg": 56615,
	"./hook.svg": 4673,
	"./hot-x.svg": 58918,
	"./hot.svg": 38093,
	"./hpb.svg": 2998,
	"./hsr.svg": 98431,
	"./ht.svg": 73104,
	"./hum.svg": 41894,
	"./husd.svg": 36444,
	"./hvn.svg": 28200,
	"./hydro.svg": 47542,
	"./hyn.svg": 73161,
	"./hzn.svg": 68124,
	"./ibat.svg": 44470,
	"./icn.svg": 86418,
	"./icp.svg": 11044,
	"./icx.svg": 88844,
	"./id.svg": 61379,
	"./idai.svg": 81889,
	"./idex.svg": 50964,
	"./ieth.svg": 23398,
	"./ignis.svg": 45994,
	"./iknc.svg": 4805,
	"./ilink.svg": 72361,
	"./ilv.svg": 72143,
	"./imx.svg": 25278,
	"./inb.svg": 96569,
	"./inj.svg": 97153,
	"./ins.svg": 89528,
	"./io.svg": 19976,
	"./iost.svg": 31005,
	"./iota.svg": 78589,
	"./iotx.svg": 52932,
	"./iq.svg": 99758,
	"./irep.svg": 24630,
	"./iris.svg": 95265,
	"./isusd.svg": 79636,
	"./iusdc.svg": 25458,
	"./iwbtc.svg": 58365,
	"./izrx.svg": 8479,
	"./jasmy.svg": 66808,
	"./jnt.svg": 97480,
	"./joe.svg": 35434,
	"./jst.svg": 62999,
	"./jto.svg": 51229,
	"./juno.svg": 17694,
	"./jup.svg": 8469,
	"./juv.svg": 61979,
	"./kava.svg": 59007,
	"./kcs.svg": 5737,
	"./kda.svg": 24522,
	"./keep.svg": 21599,
	"./key.svg": 22817,
	"./kick.svg": 44654,
	"./kin.svg": 76722,
	"./kishu.svg": 84810,
	"./klay.svg": 84455,
	"./klv.svg": 73277,
	"./kmd.svg": 7676,
	"./knc.svg": 53178,
	"./kp3r.svg": 38774,
	"./ksm.svg": 57919,
	"./lamb.svg": 16096,
	"./land.svg": 16075,
	"./lat.svg": 90551,
	"./lazio.svg": 17681,
	"./lba.svg": 50551,
	"./lcx.svg": 26425,
	"./ldo.svg": 47451,
	"./lend.svg": 20503,
	"./leo.svg": 94680,
	"./lever.svg": 12352,
	"./lina.svg": 30206,
	"./link.svg": 48308,
	"./lista.svg": 84869,
	"./lit.svg": 24719,
	"./lky.svg": 74320,
	"./ln.svg": 84382,
	"./loka.svg": 73851,
	"./loki.svg": 99267,
	"./lon.svg": 62139,
	"./looks.svg": 74308,
	"./loom.svg": 26611,
	"./lpt.svg": 67204,
	"./lqd.svg": 16183,
	"./lqty.svg": 24540,
	"./lrc.svg": 89333,
	"./lsk.svg": 5738,
	"./ltc.svg": 77695,
	"./lto.svg": 13643,
	"./lun.svg": 56281,
	"./luna.svg": 90090,
	"./lunc.svg": 16072,
	"./lxt.svg": 18492,
	"./lym.svg": 68662,
	"./magic.svg": 55837,
	"./maha.svg": 52499,
	"./maid.svg": 76129,
	"./man.svg": 25232,
	"./mana.svg": 85793,
	"./manta.svg": 99685,
	"./mars.svg": 95631,
	"./mask.svg": 1236,
	"./math.svg": 34110,
	"./matic.svg": 45598,
	"./matter.svg": 57603,
	"./mav.svg": 29848,
	"./mbc.svg": 82264,
	"./mbl.svg": 85151,
	"./mbox.svg": 84476,
	"./mc.svg": 31192,
	"./mco.svg": 90703,
	"./mcx.svg": 73152,
	"./mda.svg": 3252,
	"./mds.svg": 10342,
	"./mdx.svg": 49293,
	"./med.svg": 62758,
	"./medx.svg": 17362,
	"./meme.svg": 42592,
	"./merl.svg": 13676,
	"./met.svg": 57014,
	"./metis.svg": 94762,
	"./mew.svg": 93653,
	"./mfg.svg": 21456,
	"./mft.svg": 41299,
	"./mim.svg": 42667,
	"./mina.svg": 23417,
	"./mir.svg": 74172,
	"./mith.svg": 69270,
	"./mkr.svg": 45074,
	"./mln.svg": 90891,
	"./mngo.svg": 80319,
	"./mob.svg": 25894,
	"./mod.svg": 93624,
	"./mot.svg": 45768,
	"./movr.svg": 15348,
	"./mpl.svg": 27621,
	"./msn.svg": 81998,
	"./mta.svg": 97860,
	"./mth.svg": 83053,
	"./mtl.svg": 37809,
	"./mtn.svg": 87987,
	"./mvc.svg": 29548,
	"./mvl.svg": 56427,
	"./mvp.svg": 66959,
	"./mwat.svg": 91547,
	"./mwc.svg": 14127,
	"./mxm.svg": 16364,
	"./myb.svg": 21916,
	"./naka.svg": 53059,
	"./nano.svg": 64478,
	"./nas.svg": 23254,
	"./nav.svg": 6555,
	"./ncash.svg": 95611,
	"./nct.svg": 23779,
	"./near.svg": 64562,
	"./nebl.svg": 35869,
	"./nec.svg": 71938,
	"./neo.svg": 61510,
	"./new.svg": 12158,
	"./nex.svg": 12601,
	"./nexo.svg": 23836,
	"./nexxo.svg": 60798,
	"./nfp.svg": 34856,
	"./nft.svg": 948,
	"./ngc.svg": 82440,
	"./niox.svg": 38065,
	"./nkn.svg": 86289,
	"./nlg.svg": 47585,
	"./nmr.svg": 67995,
	"./noia.svg": 85415,
	"./not.svg": 2671,
	"./nper.svg": 33655,
	"./npxs.svg": 51597,
	"./nrg.svg": 59379,
	"./nrve.svg": 46627,
	"./ntrn.svg": 71450,
	"./nu.svg": 17611,
	"./nul.svg": 12789,
	"./nuls.svg": 99708,
	"./nxs.svg": 8529,
	"./nxt.svg": 99534,
	"./oag.svg": 11823,
	"./oax.svg": 1528,
	"./ocean.svg": 92062,
	"./ocn.svg": 95784,
	"./ode.svg": 26298,
	"./og.svg": 49758,
	"./ogn.svg": 34756,
	"./ohm.svg": 32670,
	"./okb.svg": 5188,
	"./okt.svg": 72458,
	"./olt.svg": 9891,
	"./om.svg": 8372,
	"./omg.svg": 32931,
	"./omni.svg": 59967,
	"./ondo.svg": 93580,
	"./one.svg": 76728,
	"./ong.svg": 12858,
	"./onion.svg": 18895,
	"./ont.svg": 36793,
	"./ooki.svg": 87034,
	"./op.svg": 66641,
	"./open.svg": 52868,
	"./opium.svg": 78436,
	"./orbs.svg": 69618,
	"./orc.svg": 59978,
	"./ordi.svg": 34950,
	"./orn.svg": 78735,
	"./osmo.svg": 75734,
	"./ost.svg": 46738,
	"./ovc.svg": 83950,
	"./oxt.svg": 935,
	"./pBTC.svg": 89673,
	"./pai.svg": 74342,
	"./paint.svg": 40200,
	"./pal.svg": 80907,
	"./par.svg": 970,
	"./part.svg": 72475,
	"./pax.svg": 14023,
	"./paxg.svg": 89722,
	"./pay.svg": 26902,
	"./pbr.svg": 89656,
	"./pda.svg": 5417,
	"./pendle.svg": 67138,
	"./people.svg": 73397,
	"./pepe.svg": 11868,
	"./perl.svg": 74047,
	"./perp.svg": 21019,
	"./pha.svg": 94997,
	"./phb.svg": 6774,
	"./pickle.svg": 58030,
	"./pivx.svg": 69779,
	"./pixel.svg": 22612,
	"./plDAI.svg": 94886,
	"./plUSDC.svg": 49651,
	"./play.svg": 56458,
	"./plr.svg": 61570,
	"./png.svg": 44929,
	"./pnk.svg": 24149,
	"./pnt.svg": 3682,
	"./poa.svg": 55512,
	"./poe.svg": 1572,
	"./pokt.svg": 65330,
	"./pols.svg": 29124,
	"./poly.svg": 34222,
	"./polyx.svg": 8314,
	"./pond.svg": 25041,
	"./pool.svg": 60534,
	"./portal.svg": 3758,
	"./porto.svg": 59872,
	"./powr.svg": 24088,
	"./ppay.svg": 96110,
	"./ppc.svg": 68063,
	"./ppp.svg": 47420,
	"./ppt.svg": 60560,
	"./prcl.svg": 54015,
	"./pre.svg": 61943,
	"./premia.svg": 35818,
	"./prl.svg": 31822,
	"./pro.svg": 26189,
	"./prom.svg": 88274,
	"./pros.svg": 96548,
	"./prq.svg": 379,
	"./psg.svg": 5994,
	"./pst.svg": 73609,
	"./pundix.svg": 89440,
	"./pyr.svg": 91941,
	"./pyth.svg": 41017,
	"./qash.svg": 78499,
	"./qbit.svg": 36806,
	"./qi.svg": 18350,
	"./qkc.svg": 30103,
	"./qlc.svg": 80458,
	"./qnt.svg": 97279,
	"./qsp.svg": 55692,
	"./qtum.svg": 89537,
	"./quick.svg": 92217,
	"./r.svg": 39966,
	"./raca.svg": 1015,
	"./rae.svg": 69364,
	"./rare.svg": 37276,
	"./rari.svg": 23976,
	"./ray.svg": 87072,
	"./rcn.svg": 71125,
	"./rdd.svg": 22609,
	"./rdn.svg": 46740,
	"./rdnt.svg": 38784,
	"./ren.svg": 1451,
	"./rep.svg": 79901,
	"./req.svg": 51356,
	"./rev.svg": 49283,
	"./rez.svg": 40455,
	"./rfox.svg": 12177,
	"./rhoc.svg": 2912,
	"./rif.svg": 21167,
	"./rlc.svg": 59081,
	"./rndr.svg": 59730,
	"./ron.svg": 13049,
	"./rook.svg": 77971,
	"./rose.svg": 49449,
	"./rpl.svg": 92746,
	"./rpx.svg": 17126,
	"./rsr.svg": 44897,
	"./rss3.svg": 32851,
	"./rsv.svg": 13437,
	"./rune.svg": 38476,
	"./rvn.svg": 45906,
	"./s.svg": 83695,
	"./saga.svg": 84736,
	"./sai.svg": 45501,
	"./salt.svg": 32204,
	"./san.svg": 11570,
	"./sand.svg": 35922,
	"./sar.svg": 41254,
	"./sc.svg": 94206,
	"./scrl.svg": 75732,
	"./scrt.svg": 6476,
	"./sdt.svg": 29583,
	"./seele.svg": 67348,
	"./sefi.svg": 84427,
	"./sei.svg": 25241,
	"./sem.svg": 40725,
	"./sfi.svg": 83347,
	"./sfp.svg": 21465,
	"./shib.svg": 71288,
	"./shr.svg": 53629,
	"./shuf.svg": 58224,
	"./sia.svg": 38954,
	"./skl.svg": 47038,
	"./sky.svg": 87251,
	"./slerf.svg": 72854,
	"./slp.svg": 79691,
	"./slt.svg": 35927,
	"./smart.svg": 34231,
	"./snc.svg": 82498,
	"./sngls.svg": 56905,
	"./snm.svg": 22948,
	"./snt.svg": 68989,
	"./snx.svg": 39513,
	"./sol.svg": 87970,
	"./soul.svg": 35813,
	"./sov.svg": 3880,
	"./spell.svg": 88698,
	"./spn.svg": 25057,
	"./srm.svg": 9048,
	"./ssv.svg": 59500,
	"./stake.svg": 63874,
	"./steem.svg": 55320,
	"./step.svg": 91570,
	"./steth.svg": 97274,
	"./stg.svg": 74268,
	"./stmx.svg": 53634,
	"./storj.svg": 57032,
	"./storm.svg": 46215,
	"./stpt.svg": 58341,
	"./strat.svg": 56834,
	"./strax.svg": 46406,
	"./strk.svg": 82824,
	"./stx.svg": 24363,
	"./sub.svg": 68738,
	"./sui.svg": 44073,
	"./sun.svg": 58310,
	"./super.svg": 88661,
	"./suqa.svg": 4386,
	"./sushi.svg": 74410,
	"./suter.svg": 73481,
	"./swap.svg": 53981,
	"./sweat.svg": 6388,
	"./swth.svg": 5142,
	"./sxdt.svg": 92533,
	"./sxp.svg": 5183,
	"./syn.svg": 90842,
	"./sys.svg": 15983,
	"./tao.svg": 55300,
	"./tbtc.svg": 61613,
	"./tct.svg": 49365,
	"./tel.svg": 5363,
	"./tfuel.svg": 8020,
	"./thc.svg": 93995,
	"./theta.svg": 18888,
	"./thr.svg": 63050,
	"./tia.svg": 94282,
	"./tio.svg": 50364,
	"./titan.svg": 23914,
	"./tkn.svg": 39287,
	"./tko.svg": 33958,
	"./tky.svg": 89032,
	"./tlm.svg": 32633,
	"./tnb.svg": 86056,
	"./tnc.svg": 67801,
	"./tnsr.svg": 80857,
	"./tnt.svg": 66182,
	"./tomo.svg": 68759,
	"./ton.svg": 26099,
	"./toncoin.svg": 71360,
	"./torn.svg": 14579,
	"./tpay.svg": 74330,
	"./trac.svg": 74830,
	"./trb.svg": 53900,
	"./tribe.svg": 19288,
	"./trig.svg": 55690,
	"./troy.svg": 70930,
	"./trtl.svg": 28394,
	"./tru.svg": 82467,
	"./trx.svg": 50070,
	"./tryb.svg": 65015,
	"./tube.svg": 36290,
	"./turbo.svg": 61760,
	"./tusd.svg": 39904,
	"./twt.svg": 78561,
	"./ubq.svg": 91778,
	"./ubt.svg": 42079,
	"./uft.svg": 21835,
	"./ult.svg": 24105,
	"./ulti.svg": 22530,
	"./uma.svg": 23019,
	"./uncx.svg": 25260,
	"./unfi.svg": 21594,
	"./uni.svg": 4278,
	"./unn.svg": 61113,
	"./uos.svg": 33135,
	"./upp.svg": 3865,
	"./usdc.svg": 80679,
	"./usdp.svg": 81412,
	"./usds.svg": 86007,
	"./usdt.svg": 90936,
	"./ustc.svg": 20132,
	"./utk.svg": 14518,
	"./uuu.svg": 27023,
	"./value.svg": 42647,
	"./vanry.svg": 71824,
	"./velo.svg": 85104,
	"./venom.svg": 12739,
	"./veri.svg": 12088,
	"./vest.svg": 51626,
	"./vet.svg": 49333,
	"./vgx.svg": 67675,
	"./via.svg": 91524,
	"./vib.svg": 34647,
	"./vibe.svg": 20808,
	"./vic.svg": 47110,
	"./vidt.svg": 21511,
	"./vikky.svg": 83266,
	"./vin.svg": 30067,
	"./vite.svg": 70230,
	"./viu.svg": 66984,
	"./vlx.svg": 59422,
	"./voxel.svg": 25096,
	"./vra.svg": 32485,
	"./vrs.svg": 73031,
	"./vsp.svg": 68471,
	"./vsys.svg": 77137,
	"./vtc.svg": 18285,
	"./vtho.svg": 47117,
	"./w.svg": 74851,
	"./wabi.svg": 41151,
	"./wan.svg": 6174,
	"./water.svg": 51921,
	"./waves.svg": 36966,
	"./waxp.svg": 14416,
	"./wbeth.svg": 35952,
	"./wbtc.svg": 93780,
	"./wct.svg": 36698,
	"./wexpoly.svg": 66302,
	"./whale.svg": 811,
	"./wib.svg": 70562,
	"./wif.svg": 85486,
	"./win.svg": 52806,
	"./wing.svg": 43685,
	"./wings.svg": 14988,
	"./wld.svg": 65115,
	"./wnxm.svg": 92346,
	"./woo.svg": 48661,
	"./wpr.svg": 87337,
	"./wrx.svg": 51833,
	"./wsm.svg": 37939,
	"./wtc.svg": 7596,
	"./wxt.svg": 50703,
	"./xai.svg": 54062,
	"./xas.svg": 56372,
	"./xch.svg": 71093,
	"./xchf.svg": 26033,
	"./xec.svg": 65472,
	"./xem.svg": 3270,
	"./xhv.svg": 98850,
	"./xin.svg": 68713,
	"./xlm.svg": 25261,
	"./xlq.svg": 78873,
	"./xmark.svg": 95911,
	"./xmr.svg": 54281,
	"./xmx.svg": 7795,
	"./xnk.svg": 79821,
	"./xno.svg": 50929,
	"./xns.svg": 67317,
	"./xor.svg": 55555,
	"./xrd.svg": 44798,
	"./xrp.svg": 47106,
	"./xsn.svg": 30443,
	"./xsr.svg": 36527,
	"./xtz.svg": 586,
	"./xvg.svg": 36721,
	"./xyo.svg": 39560,
	"./xzc.svg": 16809,
	"./yfi.svg": 80138,
	"./ygg.svg": 1375,
	"./yoyo.svg": 12532,
	"./zai.svg": 70584,
	"./zb.svg": 54344,
	"./zco.svg": 26588,
	"./zec.svg": 70342,
	"./zen.svg": 2323,
	"./zent.svg": 64805,
	"./zero.svg": 45282,
	"./zeta.svg": 34986,
	"./zil.svg": 10413,
	"./zk.svg": 9825,
	"./zks.svg": 50224,
	"./zro.svg": 5039,
	"./zrx.svg": 87488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67806;